import { Observable } from 'rxjs';
import { MerchantProvisionResult } from '@app/domain/models/tpv/merchant.model';
import {
  ProvisionAssistedRequest,
  ProvisionMerchantRequest,
  ProvisionMerchantCompanyAnchoredRequest,
} from '@app/data/dtos/tpv/provision.dto';

/**
 * Port abstracto para el alta de comercios en el TPV (escritura).
 * Permiso backend: IsAdmin. Header `Idempotency-Key` obligatorio.
 */
export abstract class MerchantProvisionRepository {
  /** Alta completa (account-centric): envía los 4 bloques + polipay_account_id. */
  abstract provision(
    request: ProvisionMerchantRequest,
    idempotencyKey: string,
  ): Observable<MerchantProvisionResult>;

  /** Alta asistida: solo datos de sucursal; identidad fiscal del KYC. */
  abstract provisionAssisted(
    request: ProvisionAssistedRequest,
    idempotencyKey: string,
  ): Observable<MerchantProvisionResult>;

  /** Alta company-anchored (tenant TPV-only): sin polipay_account_id; se ancla por id_company. */
  abstract provisionCompanyAnchored(
    idCompany: string,
    request: ProvisionMerchantCompanyAnchoredRequest,
    idempotencyKey: string,
  ): Observable<MerchantProvisionResult>;
}
